<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="1050px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini">
          <el-form-item label="日期">
            <form-date-range :form="searchForm" startKey="startDate" :usingTime="false" endKey="endDate" valueFormat="yyyy-MM-dd HH:mm:ss"> </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
      <div class="btn-box"></div>
      <el-table
        :data="tableData.list"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        height="300"
        ref="table"
        border
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="fileName" label="文件名" min-width="180" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="planTime" label="超时导入月份" min-width="105"></el-table-column>
        <el-table-column prop="importType" label="超时导入类型" width="140"></el-table-column>
        <el-table-column prop="createUserName" label="提报人" width="80"></el-table-column>
        <el-table-column prop="lastUpdateTime" label="提报时间" width="160"></el-table-column>
        <el-table-column prop="reason" label="原因" width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态" width="160px" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'PENDING'">待导入</span>
            <span v-if="scope.row.status === 'PROCESSING'">导入中</span>
            <el-link type="primary" :underline="false" v-if="scope.row.status === 'PROCESSED'">导入完成</el-link>
            <template v-if="scope.row.status === 'ERROR'">
              <el-link type="warning" :underline="false">导入失败</el-link>
              <el-link type="info" :underline="false" style="font-size: 12px" @click="log(scope.row)">查看错误日志</el-link>
            </template>
            <el-link type="warning" :underline="false" v-if="scope.row.status === 'FAILED'">导入失败</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="downloadRes(row.downloadUrl, row.fileName)" :disabled="row.status == 'ERROR'">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 60, 90]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        >
        </el-pagination>
      </div>
    </q-dialog>
    <q-dialog
      :visible="dialogVisible"
      title="-审批文件号维护"
      width="50%"
      :innerScroll="true"
      :innerHeight="300"
      @confirm="cancel"
      @cancel="cancel"
      @close="cancel"
    >
      <div style="padding-bottom: 15px; line-height: 22px" v-html="errorMsg"></div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '超时导入记录';
    },
    name() {
      return this.$store.state.user.name;
    },
    isAll() {
      return this.searchForm.type == 1;
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      searchForm: {
        fileName: '',
      },
      rules: {},
      tableData: {
        list: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      visibleColumns: [],
      errorMsg: '',
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    setEndDateToLastSecond() {
      if (this.searchForm.endDate) {
        this.searchForm.endDate = this.searchForm.endDate.substring(0, 10) + ' 23:59:59';
      }
    },
    onSearch() {
      this.setEndDateToLastSecond();
      this.tableData.pagNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm = {};
      this.onSearch();
    },
    async init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          appCode: 'ec-pc-new',
          reportName: 'prePlanGoodsTimeOutAdjust',
          reportType: 'IMPORT',
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.common
        .excelTaskList({ data: data })
        .then(({ data }) => {
          this.tableData = data;
          this.tableData.list = data.list.map((item) => {
            const paramMapObj = JSON.parse(item.paramMap);
            return {
              ...item,
              storeName: paramMapObj.find((p) => p.fieldName === 'storeId').columnValue || '',
              planTime: paramMapObj.find((p) => p.fieldName === 'planTime').columnValue || '',
              importType: paramMapObj.find((p) => p.fieldName === 'prePlanAdjustImportType').columnValue || '',
              reason: paramMapObj.find((p) => p.fieldName === 'reason') ? paramMapObj.find((p) => p.fieldName === 'reason').columnValue : '',
            };
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    //错误状态显示log
    log(row) {
      this.errorMsg = row.execResults;
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    //去除后缀
    removeFileExtension(fileName) {
      if (!fileName) return '';
      return fileName.replace(/\.[^/.]+$/, '');
    },
    async downloadRes(filePath, fileName) {
      let url = filePath;
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      const pureFileName = this.removeFileExtension(fileName);
      a.download = pureFileName + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex
  height: 40px
  align-items: center
  justify-content: space-between
  padding-bottom: 10px
}

.btn-box {
  text-align: right
  padding-bottom: 10px
}

.footer {
  text-align: right
  margin-top: 10px
}

>>> .el-dialog {
  margin-top: 50px !important
}
>>> .search {
  padding: 0
}
</style>
